type UnixTimestamp = number;
type ISODateString = string;

const createExpirationDate = (expiresAt: UnixTimestamp): ISODateString => new Date(expiresAt * 1000).toISOString();

export default createExpirationDate;
